import { LabcoreFile } from "./labcore-file.model";
import { LabcoreStudy } from "./labcore-study.model";

export class LabcoreOrder{
    constructor(
        public OrderDate?: Date,
        public OrderNumber?: string,
        public OrderStatus?: string,
        public ResultPDF?: LabcoreFile,
        public Studies?: LabcoreStudy[]
    ){}    
}


// WEBPACK FOOTER //
// /app/src/app/shared/models/labcore-order.model.ts